<template>
  <div class="uploader">
    <div class="upload-progress-wrapper">
      <v-progress-linear v-if="showProgress"
                         :indeterminate="processing"
                         v-model="fileProgress">
      </v-progress-linear>
    </div>

    <div v-if="hasFiles" class="center-align px-2 py-3">
      <v-tooltip bottom>
        <a slot="activator" :href="project.file.files.preview" target="_blank">
          <img :src="project.file.thumbs.medium" alt="" class="elevation-5" width="250">
        </a>
        <span>Preview File</span>
      </v-tooltip>
      <br>
      <v-btn flat @click.prevent="saveItem(project.file.files.preview, true)">Preview File</v-btn>
    </div>

    <div class="center-align px-2 py-2">
      <vue-transmit v-bind="transmitOptions"
                    v-on:sending="showProgress = true"
                    v-on:upload-progress="updateProgress"
                    v-on:success="onUploadSuccess"
                    v-on:error="errorUploading"
                    v-on:timeout="onTimeout"
                    ref="uploader">
        <v-btn color="primary" large v-if="hasFiles">Select a new PDF File</v-btn>
        <div v-else class="upload-file-area elevation-4 v-align mb-3">
          <br>
          <v-icon class="mt-3 display-3">mdi-file-pdf-box</v-icon><br>
          <br>
          Drag &amp; Drop<br>Your PDF File Here<br>
          <br>
          or<br>
          <br>
          <v-btn color="primary" large>Select a PDF File</v-btn>
        </div>
      </vue-transmit>
    </div>
  </div>
</template>

<style scoped>
.upload-file-area {
  width: 250px;
  height: 325px;
}
</style>

<script>
import Events from '@/api/events'

export default {
  props: {
    project: Object
  },

  data () {
    return {
      fileProgress: 0,
      showProgress: false,
      processing: false,
      transmitOptions: {
        acceptedFileTypes: ['application/pdf'],
        createImageThumbnailsblank: false,
        maxFiles: 1,
        maxFileSize: 1000000000,
        paramName: 'pdf[file]',
        headers: {
          'GUNGHO-ACCESS-TOKEN': this.$session.get('sessionToken')
        },
        params: {
          'product_id': false
        }
      },
      requiredRules: [
        v => !!v || 'Cannot be blank'
      ]
    }
  },

  computed: {
    hasFiles () {
      return !!this.project.file && !!this.project.file_id
    },

    width () {
      if (!!this.project || !!this.project.product || !!this.project.product.properties) return 8.5
      var obj = this.project.product.properties.find(function (obj) { return obj.name === 'width' })
      return obj.default
    },

    length () {
      if (!!this.project || !!this.project.product || !!this.project.product.properties) return 11
      var obj = this.project.product.properties.find(function (obj) { return obj.name === 'length' })
      return obj.default
    },

    binding () {
      return this.project.file.binding
    },

    ink () {
      return this.project.file.ink
    }
  },

  methods: {
    updateProgress (file, progress) {
      this.fileProgress = progress
      if (progress >= 100) this.processingUpload()
    },

    processingUpload (file) {
      this.processing = true
      Events.$emit('toast', 'Building preview')
    },

    onUploadSuccess (file, data) {
      this.showProgress = false
      this.$refs.uploader.removeAllFiles({cancelInProgressUploads: false})

      if (data.error) return this.uploadError(data.error)

      this.project.file_id = data.pdf.id
      this.project.file.files = data.pdf.files
      this.project.file.thumbs = data.pdf.thumbs
      this.project.file.original_pages = data.pdf.original_pages
      this.project.file.content_pages = data.pdf.content_pages > 0 ? data.pdf.content_pages : data.pdf.original_pages
      Events.$emit('toast', 'File uploaded')
    },

    uploadError (error) {
      Events.$emit('error', error.message)
    },

    onTimeout () {
      console.log('Upload processing timeout')
    },

    errorUploading (file) {
      this.showProgress = false
      this.$refs.uploader.removeAllFiles({cancelInProgressUploads: false})
      console.log('Upload Error: ', this.fileUploadUrl(), JSON.parse(JSON.stringify(file)))
      Events.$emit('error', 'File upload error (unknown)')
    },

    triggerBrowse () {
      this.$refs.uploader.triggerBrowseFiles()
    },

    fileType () {
      var fileType = this.project.file_type
      if (fileType) return fileType.toLowerCase()
      else return 'pdf'
    },

    fileUploadUrl () {
      if (this.project.file_id) {
        return `${process.env.API_URL}/${this.fileType()}s/${this.project.file.id}`
      } else {
        return `${process.env.API_URL}/${this.fileType()}s`
      }
    }
  },

  beforeMount () {
    this.transmitOptions.method = 'post'
    this.transmitOptions.url = this.fileUploadUrl()
  }
}
</script>



// WEBPACK FOOTER //
// upload.vue?3037608e